<app-main-header></app-main-header>
<div class="app-contents">
  <app-clients-table></app-clients-table>
</div>
<app-main-footer></app-main-footer>
